import { SimpleTreeItemWrapper, TreeItemComponentProps } from 'dnd-kit-sortable-tree';
import { forwardRef } from 'react';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import {
  TableColumnWidgetItemProps,
  useTableColumnWidgetItem,
} from './use-table-column-widget-item';

export const TableColumnWidgetItem = forwardRef<
  HTMLDivElement,
  TreeItemComponentProps<TableColumnWidgetItemProps>
>((props, ref) => {
  const { item } = props;

  const { checked, handleClick } = useTableColumnWidgetItem({
    columnId: item.columnId,
    tableId: item.tableId,
  });

  return (
    <SimpleTreeItemWrapper {...props} ref={ref}>
      <Checkbox label={item.label} onClick={() => handleClick()} checked={checked} />
    </SimpleTreeItemWrapper>
  );
});
